import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { EstudianteRequerimientosDTO } from '../../../../core/models/titulacion/estudianteRequerimientos-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class EstudianteRequerimientosService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getEstudianteRequerimientosService() {
        return this.http.get<BodyListResponse<EstudianteRequerimientosDTO>>(
            API_URL + '/api/v1/estudianteRequerimientos/todos'
        );
    }

    guardarEstudianteRequerimientosService(estudianteRequerimientosDTO: EstudianteRequerimientosDTO) {
        return this.http.post(API_URL + '/api/v1/estudianteRequerimientos', estudianteRequerimientosDTO);
    }

    getEstudianteRequerimientosPorCodigoRequerimientoEstudianteService(codigoRequerimientoEstudiante: string) {
        return this.http.get<BodyResponse<EstudianteRequerimientosDTO>>(
            API_URL + '/api/v1/estudianteRequerimientos/' + codigoRequerimientoEstudiante
        );
    }
}
